import { render, staticRenderFns } from "./ContractorRIDC.vue?vue&type=template&id=19a72f6a&scoped=true&"
import script from "./ContractorRIDC.vue?vue&type=script&lang=ts&"
export * from "./ContractorRIDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a72f6a",
  null
  
)

export default component.exports